export default __webpack_public_path__ + "static/seo-audit-db30f4165eb5b8cc15f6fe3d11eb2445.jpg";